import { memo } from "react";
import { Col, Row } from "react-bootstrap";

import { DEFAULT_VALUE } from "../../constants";
import {
  BRAND_REPORT_LABELS,
  BRAND_REPORT_SECTION_TITLE,
} from "../../constants/brandReport.constants";
import { compactNumberFormat, toTestIdSlug } from "../../../../shared";
import ProgressCardsSection from "./components/progressCardsSection";
import BreakdownSection from "./components/breakdownSection";

const BrandReportSection = ({ title, data, isSingleSection = false }) => {
  const sectionTestId = toTestIdSlug(title);
  const titleClassName =
    title === BRAND_REPORT_SECTION_TITLE.POS ? "pos-title" : "online-title";

  return (
    <Col xs={12} lg={isSingleSection ? 12 : 6}>
      <div
        className="bg-white rounded-3 shadow-sm p-3"
        data-testid={`brand-report-section-${sectionTestId}`}
      >
        <div className="d-flex justify-content-between align-items-center p-2">
          <span
            className={`px-3 py-1 space-mono-text border-primary fw-bolder rounded-2 small ${titleClassName}`}
          >
            {title}
          </span>
          <div className="text-end">
            <p className="text-secondary small mb-1 space-mono-text loose-text">
              {BRAND_REPORT_LABELS.TOTAL_SENT}
            </p>
            <h3
              className="fw-bolder"
              data-testid={`brand-report-section-${sectionTestId}-total-sent`}
            >
              {compactNumberFormat(
                data?.totalSurveySentCount?.value ?? DEFAULT_VALUE,
              )}
            </h3>
          </div>
        </div>
        <div className="card-body p-0 ">
          {isSingleSection ? (
            <Row className="g-3 px-2 m-0">
              <Col xs={12} lg={6} className="mt-0 ps-0 pe-3">
                <ProgressCardsSection data={data} sectionTitle={title} />
              </Col>
              <Col xs={12} lg={6} className="border-start mt-0 pe-0 ps-3">
                <BreakdownSection
                  data={data}
                  isSingleSection={true}
                  sectionTitle={title}
                />
              </Col>
            </Row>
          ) : (
            <div className="d-flex flex-column gap-3 p-3">
              <ProgressCardsSection data={data} sectionTitle={title} />
              <BreakdownSection
                data={data}
                isSingleSection={false}
                sectionTitle={title}
              />
            </div>
          )}
        </div>
      </div>
    </Col>
  );
};

export default memo(BrandReportSection);
